(function () {
  const CONFIG = {
    mainImageSelector: '.product__media-gallery .is-active .product__media img, .product__media-list .product__media img, .product__media img, .product-single__photo img',
    buyButtonsSelector: '.product-form__buttons, .product-form__submit, product-form',
    priceSelector: '.price__regular .price-item--regular, .price-item--sale'
  };

  let variantsData = [];
  const STATE = {
    garment: '',
    color: '',
    design: '',
    size: ''
  };

  function sanitize(str) {
    if (!str) return '';
    return str.trim().toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-');
  }

  function loadVariantsData() {
    const rawEl = document.getElementById('byo-variants-data');
    if (rawEl) {
      try {
        variantsData = JSON.parse(rawEl.textContent);
      } catch (e) {
        console.error('Failed to parse BYO variants data', e);
      }
    }
  }

  function updateImage() {
    if (!STATE.garment || !STATE.color || !STATE.design) return;

    const fileName = `${sanitize(STATE.garment)}_${sanitize(STATE.color)}_${sanitize(STATE.design)}.png`;
    const mainImg = document.querySelector(CONFIG.mainImageSelector);

    if (mainImg && mainImg.src) {
      const currentSrc = mainImg.src;
      const baseUrl = currentSrc.substring(0, currentSrc.lastIndexOf('/') + 1);
      const newUrl = baseUrl + fileName;

      mainImg.src = newUrl;
      if (mainImg.srcset) mainImg.srcset = newUrl;
    }
  }

  function updateLabels() {
    const garmentLabel = document.getElementById('byo-garment-label');
    const colorLabel = document.getElementById('byo-color-label');
    const designLabel = document.getElementById('byo-design-label');
    const sizeLabel = document.getElementById('byo-size-label');

    if (garmentLabel) garmentLabel.textContent = STATE.garment || 'Select Garment';
    if (colorLabel) colorLabel.textContent = STATE.color || 'Select Color';
    if (designLabel) designLabel.textContent = STATE.design || 'Select Design';
    if (sizeLabel) sizeLabel.textContent = STATE.size || 'Select Size';
  }

  function updateWorkflow() {
    const step2 = document.getElementById('byo-step-2');
    const step3 = document.getElementById('byo-step-3');
    const step4 = document.getElementById('byo-step-4');
    const buyButtons = document.querySelector(CONFIG.buyButtonsSelector);

    // Step 2: Color (Show if Garment is picked)
    if (step2) {
      if (STATE.garment) {
        step2.classList.remove('byo-hidden');
        step2.classList.add('byo-visible');
      } else {
        step2.classList.add('byo-hidden');
        step2.classList.remove('byo-visible');
      }
    }

    // Step 3: Design (Show if Garment + Color are picked)
    if (step3) {
      if (STATE.garment && STATE.color) {
        step3.classList.remove('byo-hidden');
        step3.classList.add('byo-visible');
      } else {
        step3.classList.add('byo-hidden');
        step3.classList.remove('byo-visible');
      }
    }

    // Step 4: Size (Show if Garment + Color + Design are picked)
    if (step4) {
      if (STATE.garment && STATE.color && STATE.design) {
        step4.classList.remove('byo-hidden');
        step4.classList.add('byo-visible');
      } else {
        step4.classList.add('byo-hidden');
        step4.classList.remove('byo-visible');
      }
    }

    // Step 5: Add to Cart Buttons
    if (buyButtons) {
      if (STATE.garment && STATE.color && STATE.design && STATE.size) {
        buyButtons.classList.remove('byo-hidden');
        buyButtons.classList.add('byo-visible');
      } else {
        buyButtons.classList.add('byo-hidden');
        buyButtons.classList.remove('byo-visible');
      }
    }
  }

  function syncVariantIdAndPrice() {
    if (!STATE.garment || !STATE.size || !variantsData.length) return;

    // Find native variant where option1 == Garment and option2 == Size
    const match = variantsData.find(v => {
      return (
        v.option1.toLowerCase() === STATE.garment.toLowerCase() &&
        v.option2.toLowerCase() === STATE.size.toLowerCase()
      );
    });

    if (match) {
      // 1. Update the hidden input in our component
      const hiddenInput = document.getElementById('byo-final-variant-id');
      if (hiddenInput) hiddenInput.value = match.id;

      // 2. Also update any active Shopify theme native product form inputs
      document.querySelectorAll('input[name="id"]:not(#byo-final-variant-id), select[name="id"]').forEach(el => {
        el.value = match.id;
      });

      // 3. Update dynamic price display if present
      if (match.price) {
        const formattedPrice = `$${(match.price / 100).toFixed(2)}`;
        const priceEl = document.querySelector(CONFIG.priceSelector);
        if (priceEl) priceEl.textContent = formattedPrice;
      }
    }
  }

  function handleSelection(type, value) {
    STATE[type] = value;
    updateLabels();
    updateWorkflow();
    updateImage();
    syncVariantIdAndPrice();
  }

  function init() {
    loadVariantsData();

    const builder = document.getElementById('byo-builder');
    if (!builder) return;

    builder.addEventListener('change', (e) => {
      if (e.target.classList.contains('js-byo-garment')) {
        handleSelection('garment', e.target.value);
      } else if (e.target.classList.contains('js-byo-color')) {
        handleSelection('color', e.target.value);
      } else if (e.target.classList.contains('js-byo-design')) {
        handleSelection('design', e.target.value);
      } else if (e.target.classList.contains('js-byo-size')) {
        handleSelection('size', e.target.value);
      }
    });

    // Start with buy buttons hidden until configuration is completed
    const buyButtons = document.querySelector(CONFIG.buyButtonsSelector);
    if (buyButtons) buyButtons.classList.add('byo-hidden');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();